import React from 'react';

import share from '../../../images/shrink.svg';

import { FOHImage } from '../../ingredients';

export const FOHShrinkIcon = () => (
  <FOHImage source={{ uri: share }} style={{ width: 24, height: 24 }} />
);
